import React from 'react';
import { FaUser } from 'react-icons/fa';

const QnASection = ({ questions }) => {

const formatTime = (date) => {
    if (date) {
        const d = new Date(date);
        const formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        }).format(d);
        const formattedTime = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        }).format(d);
        
        return `${formattedDate} at ${formattedTime}`;
    }
    };
      
  return (
    <div
      style={{
        height: '250px',
        overflowY: 'auto',
        flex: 1,
        border: '1px solid #ccc',
        padding: '10px',
        borderRadius: '8px',
      }}
    >
      {questions.map((qa, index) => (
        <div key={index}>
          <div
            className="d-flex flex-column mb-3 p-2 border rounded mt-2"
            style={{ backgroundColor: '#f9f9f9' }}
          >
            {/* User Info Row */}
            <div className="d-flex align-items-center mb-1">
              {qa.user_image_url ? (
                    <img 
                    src={qa.user_image_url} 
                    alt="User" 
                    style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', marginRight: '8px' }}
                    />
                ) : (
                    <FaUser size={24} className="me-2" />
                )}
              <div>
                <div className="fw-bold">{qa.asked_by}</div>
                <small className="text-muted">
                  {formatTime(qa.created_at)}
                </small>
              </div>
            </div>
            <div>
              <strong>Q:</strong> {qa.content}
            </div>
          </div>

          <div>
            <strong>A:</strong> {qa.answer}
          </div>

          <hr
            style={{
              border: 'none',
              borderTop: '1px dashed grey',
              margin: '10px 0',
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default QnASection;
